export const convertObjectToQuery = (obj:object) => {
    const queryString = Object.entries(obj)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value && value.toString())}`)
        .join("&");

    return `?${queryString}`;
}

export function getItemById<T>(arr: T[], key: keyof T, id: number | string): T | undefined {
    try {
        return arr.find(item => item[key] === id);
    }
    catch (e) {
        console.log(e);
        return undefined;
    }
}

export function convertArrayToDropdownlist<T>(arr: T[], key_id: keyof T, key_label: keyof T):Array<string> {
    let a:Array<string> = []
    arr.forEach(el => {
        a.push(`${el[key_id]}_${el[key_label]}`)
    });
    return a;
}